<template>
    <div>
        <v-dialog v-model="addStaffDialog" max-width="900px">
          <v-card>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <span style="font-weight: bold;" class="mb-2 mt-6">
                            {{ $t('pmreviewexercise.addstafffor') }} &nbsp;
                            </span>
                            <span class="page_title_value mb-2 mt-6">
                            {{ parentObject.formData.reviewcode }}
                            </span>
                        </v-col>
                    </v-row>
                    <div>
                        <v-row class="pb-n4 mb-n4 mt-6">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                v-model="staffData.staffid"
                                dense
                                :items="filteredStaffList"
                                @input="updateValue"
                                @change="changeStaff(staffData.staffid)"
                            ></v-autocomplete>
                        </v-row>

                        <v-row class="pb-n4 mt-n8">
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    v-model="staffData.staffcode"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="staffData.staffcompany"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveStaffDialog">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeStaffDialog">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="crud-toolbar">
            <div class="crud-toolbar-left">
                <v-btn v-if="!parentObject.isWizard" color="primary" dark @click="openAddStaffDialog">+</v-btn>
                <v-btn v-if="!parentObject.isWizard" color="primary" dark @click="initiateWorkflow">{{ $t('performancemanagement.initiateworkflow') }}</v-btn>
            </div>
            <div class="export-icon-btns" style="display:flex;align-items:center;gap:8px;">
                <div class="gv-search" style="display:flex;align-items:center;gap:6px;background:#F8FAFF;border:1px solid #E8EDF5;border-radius:8px;padding:4px 10px;">
                    <v-icon size="16" style="color:#94A3B8;">mdi-magnify</v-icon>
                    <input v-model="search" type="text" placeholder="Search..." style="border:none;background:transparent;outline:none;font-size:0.85rem;color:#1E293B;width:180px;" />
                </div>
                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                  PDF
                </button>
                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                  CSV
                </button>
            </div>
        </div>

        <div class="staff-table-wrapper">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elevation-1"
            fixed-header
            :sort-by="['code']"
            :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': $t('vdatatable.rowsperpage')
            }"
            :items-per-page="10"
        >
                        <template v-if="!parentObject.isWizard" v-slot:[`item.action`]="{ item }">
                            <v-icon
                                small
                                class="ml-2 mr-2"
                                @click="modifyItemHandler(item)"
                            >
                                mdi-pen
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItemHandler(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
        </div><!-- end horizontal scroll wrapper -->

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
        <div v-if="isSuccess">
        <app-success
            v-bind:parentObject="{
                messageSuccess: this.successMsg,
                isSuccess: this.isSuccess,
            }"
            @close-success="goBackToGrid"
        />
        </div>
        <v-overlay :value="isInitiatingWorkflow">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import SuccessDialog from "../../../components/common/SuccessDialog";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-success": SuccessDialog
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            id: this.$route.params.id,

            formData: this.parentObject.formData,

            staffData: {
                pmreviewexerciseid: this.parentObject.formData.pmreviewexerciseid,
                pmstatusid: 4,
                startdate: this.parentObject.formData.startdate,
                enddate: this.parentObject.formData.enddate,
                staffid: null,
                staffcode: null,
                staffcompany: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            title: this.parentObject.pageTitle,
            titleValue: this.parentObject.pageTitleValue,

            staffFull: [],
            staffList: [],

            addStaffDialog: false,
            detailItem: this.parentObject.detailItem,
            dataItems: this.parentObject.detailItem,

            statusList: [],
            search: '',

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
            isSuccess: false,
            successMsg: '',
            isInitiatingWorkflow: false,
        }
    },

    computed: {
        filteredStaffList() {
            // Filter out the selected reviewer from the Name field's options
            return this.staffList.filter(staff => staff.value !== this.staffData.reviewerid);
        }
    },

    methods: {
        printPDF() {
            const doc = new jsPDF({
                orientation: "landscape",
            });

            var head = [
                { title: this.$t('columns.staffcode'),  dataKey: 'staffcode'},
                { title: this.$t('columns.name'),  dataKey: 'staffname'},
                { title: this.$t('columns.startdate'), dataKey: "startdate"},
                { title: this.$t('columns.enddate'), dataKey: "enddate" },
                { title: this.$t('columns.company'), dataKey: "compnycode" },
                { title: this.$t('columns.branch'), dataKey: "brchcode" },
                { title: this.$t('columns.department'), dataKey: "deptcode" },
                { title: this.$t('columns.section'), dataKey: "sectiocode" },
                { title: this.$t('columns.unit'), dataKey: "unitcode" },
                { title: this.$t('columns.grade'), dataKey: "grdcode" },
                { title: this.$t('columns.position'), dataKey: "poscode" },
            ];

            let body = [];
                for (var i = 0; i < this.dataItems.length; i++) {
                body.push({
                staffcode: this.dataItems[i].staffcode,
                staffname: this.dataItems[i].staffname,
                startdate: this.dataItems[i].startdate,
                enddate: this.dataItems[i].enddate,
                compnycode: this.dataItems[i].compnycode,
                brchcode: this.dataItems[i].brchcode,
                deptcode: this.dataItems[i].deptcode,
                sectiocode: this.dataItems[i].sectiocode,
                unitcode: this.dataItems[i].unitcode,
                grdcode: this.dataItems[i].grdcode,
                poscode: this.dataItems[i].poscode,
                });
            }

            doc.text(
                `${this.title} ${this.titleValue}`,
                10,
                10
            );

            doc.autoTable({
                head: [head.map(col => col.title)], // Extract titles
                body: body.map(row => Object.values(row)), // Extract values
                columnStyles: {
                    // You can set fixed widths per column key
                    staffcode: { cellWidth: 20 },
                    staffname: { cellWidth: 35 },
                    startdate: { cellWidth: 30 },
                    enddate: { cellWidth: 30 },
                    compnycode: { cellWidth: 20 },
                    brchcode: { cellWidth: 20 },
                    deptcode: { cellWidth: 20 },
                    sectiocode: { cellWidth: 20 },
                    unitcode: { cellWidth: 20 },
                    grdcode: { cellWidth: 20 },
                    poscode: { cellWidth: 20 },
                },
                startY: 20, // to leave space for the title
                styles: {
                    fontSize: 6, // optional: reduce text size to help fit columns
                    cellPadding: 1,
                }
            });

            doc.save("Appraisal Record Report " + "- " + this.parentObject.pageTitleValue + ".pdf");
        },

        async getCSV() {
            let item = this.dataItems;
            let data = [];

            for (var i = 0; i < item.length; i++) {
                data.push({
                [`${this.$t('columns.staffcode')}`]: item[i].staffcode,
                [`${this.$t('columns.name')}`]: item[i].staffname,
                [`${this.$t('columns.startdate')}`]: item[i].startdate,
                [`${this.$t('columns.enddate')}`]: item[i].enddate,
                [`${this.$t('columns.company')}`]: item[i].compnycode,
                [`${this.$t('columns.branch')}`]: item[i].brchcode,
                [`${this.$t('columns.department')}`]: item[i].deptcode,
                [`${this.$t('columns.section')}`]: item[i].sectiocode,
                [`${this.$t('columns.unit')}`]: item[i].unitcode,
                [`${this.$t('columns.grade')}`]: item[i].grdcode,
                [`${this.$t('columns.position')}`]: item[i].poscode,
                });
            }

            const csvData = this.objectToCSV(data);
            this.download(csvData);
        },

        objectToCSV(data) {
            const csvRows = [];

            // get header
            const headers = Object.keys(data[0]);
            csvRows.push(headers.join(","));

            // loop over the rows
            for (const row of data) {
                const values = headers.map((header) => {
                const escaped = ("" + row[header]).replace(/"/g, '\\"');
                return `"${escaped}"`;
                });
                csvRows.push(values.join(","));
            }
            return csvRows.join("\n");
            },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");

            a.setAttribute("hidden", "");
            a.setAttribute("href", url);
            a.setAttribute(
                "download",
                "Appraisal Record Report " + "-" + this.parentObject.pageTitleValue + ".csv"
            );

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },


        modifyItemHandler(item) {
            this.$router.push({ name: "reviewexercisestaffreviewer", params: { id: item.id, formData: this.formData, item: item} });
        },


        deleteItemHandler(item){
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmreviewexercise.deletestaff') )) {
                this.$store.dispatch('delete', {
                    url: "/reviewexercise/staff/" + item.id
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    vm.detailItem = vm.detailItem.filter(staff => staff.staffid !== item.staffid);
                    this.loadStaffList();
                    // Emit an event to update formData
                    const statusId = item.statusid;
                    vm.$emit('staffDeleted', statusId);
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        openAddStaffDialog() {
            this.addStaffDialog = true;
        },

        saveStaffDialog() {
            const vm = this;

            this.$store.dispatch('post', {url: "/reviewexercise/staff/create", payload: vm.staffData})
            .then((res) => {
                if (res.data.error) {
                    if (Array.isArray(res.data.error)) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error.join(", ");
                    } else {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    }
                } else {
                    this.loadGenerateStaff();
                    this.loadStaffList();
                    vm.$emit('staffAdded', 4);

                }
            })
            .catch((err) => {
                if (Array.isArray(err)) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err.join(", ");
                } else {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                }
            });
                
                
            // reset the form fields
            this.addStaffDialog = false;
            this.resetSelections();
        },

        async loadGenerateStaff() {
            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', { url: "/reviewexercise/staff/" + this.formData.pmreviewexerciseid })
                .then((res) => {
                    if (res.status === 200) {
                        // Temporarily store the fetched staff records locally as fetchedStaffList
                        const fetchedStaffList = res.data.rec.map(staff => {
                            // Format dates and add status code as needed
                            return {
                                ...staff,
                                startdate: staff.startdate ? moment(staff.startdate).format('YYYY-MM-DD') : null,
                                enddate: staff.enddate ? moment(staff.enddate).format('YYYY-MM-DD') : null,
                                statuscode: staff.statusid === 4 ? "INITIATED" 
                                            : staff.statusid === 5 ? "ONGOING" 
                                            : staff.statusid === 6 ? "COMPLETED" 
                                            : "UNKNOWN"
                            };
                        });

                        // Compare fetchedStaffList with detailItem and add only new records
                        const newStaffRecords = fetchedStaffList.filter(staff =>
                            !vm.detailItem.some(item => item.staffid === staff.staffid)
                        );

                        // Add new records to detailItem
                        vm.detailItem.push(...newStaffRecords);

                    } else {
                        vm.isErr = true;
                        vm.errMsg = "Failed to load staff data";
                    }
                })
                .catch((err) => {
                    console.log(err);
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
        },


        closeStaffDialog() {
            this.addStaffDialog = false;
            this.isErr = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.staffData = {
                pmreviewexerciseid: this.parentObject.formData.pmreviewexerciseid,
                pmstatusid: 4,
                startdate: this.parentObject.formData.startdate,
                enddate: this.parentObject.formData.enddate,
                staffid: null,
                staffcode: null,
                staffcompany: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },

        updateValue() {
            this.$emit("input", {
                staffid: this.staffData.staffid,
                staffcode: this.staffData.staffcode,
                staffcompany: this.staffData.staffcompany,
                stamp: 0,
                userid: this.$store.getters.userId,
            });
        },

        loadStaffList(){
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId})
            .then((res) => {

                const staffRecords = res.data.rec;

                // Filter staff records where cessadate > today's date
                const filteredStaff = staffRecords.filter(staff => {
                    const cessadate = new Date(staff.cessadate);
                    return cessadate > today;
                });

                // Ensure staff in detailItem is not included in the staffList
                const detailItemStaffIds = vm.detailItem.map(item => item.staffid);

                const uniqueStaff = filteredStaff.filter(staff => {
                    return !detailItemStaffIds.includes(staff.id);
                });

                vm.staffFull = uniqueStaff;

                // Populate staffList with the filtered data
                vm.staffList = uniqueStaff.map(staff => ({
                    text: staff.psndetails,
                    value: staff.id,
                }));
                
            }).catch((err) => {
                console.error(err)
            });

        },

        changeStaff(id) {
            let item = this.staffFull.find((item) => item.id === id);
            this.staffData.staffcode = item?.staffcode ?? null;
            this.staffData.staffcompany = item?.compnycode ?? null;
        },

        async initiateWorkflow() {
            //Only proceed if Review Exercise Status == ONGOING and isInitiatedWorkflow == false, if not send error message 
            const vm = this;

            vm.isInitiatingWorkflow = true;

            if (vm.formData.status !== "ONGOING") {
                vm.isErr = true;
                vm.errMsg = vm.$t('performancemanagement.rvexerstatusnotongoing');
                vm.isInitiatingWorkflow = false;
                return;
            }

            if (vm.formData.isInitiateWorkflow === 1) {
                vm.isErr = true;
                vm.errMsg = vm.$t('performancemanagement.workflowalreadyinitiated');
                vm.isInitiatingWorkflow = false;
                return;
            }

            // Proceed if ONGOING + Not Yet initiated
            try {
                // Exclude staff that are already ongoing (5) or completed (6)
                const skipIds = new Set(
                    vm.detailItem
                        .filter(item => item.statusid === 5 || item.statusid === 6)
                        .map(item => item.id)
                );

                const data = this.parentObject.reviewStaffReviewerList
                    .filter(d => !skipIds.has(d.pmreviewexercisedid))
                    .map(d => ({
                        ...d,
                        stamp: vm.staffData.stamp,
                        updatedby: vm.staffData.userid
                    }));

                // Step 1: collect all pmreviewexercisedid values from data
                const dataIds = new Set(data.map(d => d.pmreviewexercisedid));

                // Step 2: filter detailItem for those not in dataIds (excluding intentionally skipped status 5/6)
                const notIncluded = vm.detailItem
                .filter(item => !dataIds.has(item.id) && item.statusid !== 5 && item.statusid !== 6)
                .map(item => ({
                    id: item.id,
                    staffname: item.staffname,
                    staffcode: item.staffcode
                }));

                console.log("Items not included in data:", notIncluded);

                const res = await this.$store.dispatch('post', { url: "/rbwftran/review/create/", payload: data });

                if (res.status === 201) {
                    console.log("RESWFTRAN", res);
                    vm.isSuccess = true;

                    // Base success message
                    let message = vm.$t('performancemanagement.workflowinitiated');

                    // If there are skipped staff
                    if (notIncluded && notIncluded.length > 0) {
                        // Build the list: each line "Name - Code"
                        const skippedList = notIncluded
                            .map(s => `${s.staffname} - ${s.staffcode}`)
                            .join(', '); // newline for list format

                        message += `. The following staff are skipped because of missing reviewer. Please add the reviewer and try again to initiate their workflow: ${skippedList}`;
                    }

                    vm.successMsg = message;
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error || res.data.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in generateWfTran:', err);
                vm.isErr = true;
                vm.errMsg = (err.response && err.response.data && (err.response.data.error || err.response.data.message)) || err.message || String(err);
            } finally {
                vm.isInitiatingWorkflow = false;
            }
        },

        goBackToGrid() {
            this.isSuccess = false;
            this.$router.push({ name: "reviewexerciselist" });
        }
    },

    mounted() {
        this.loadStaffList();
    }
}
</script>

<style scoped>

/* Table wrapper: scrolls horizontally inside itself, never overflows the page */
.staff-table-wrapper {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    box-sizing: border-box;
    padding: 0 16px 16px 16px;
}

/* Force the data table to be wide enough to need scrolling but not wider than necessary */
.staff-table-wrapper .v-data-table {
    min-width: 900px;
}

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: 0;
}

.mdi-pen::before {
  margin-top: 0;
}

/* ── Toolbar ───────────────────────────────────────── */
.crud-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 12px 16px;
  width: 100%;
}
.crud-toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }

</style>